import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

// 前台路由
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/courses',
    name: 'courses',
    component: () => import(/* webpackChunkName: "courses" */ '../views/CoursesView.vue')
  },
  {
    path: '/images',
    name: 'images',
    component: () => import(/* webpackChunkName: "images" */ '../views/ImageView.vue'),
    meta: {
      title: '图片服务 - 广州市劳动保障学会'
    }
  },
  {
    path: '/courses/:id',
    name: 'course-detail',
    component: () => import(/* webpackChunkName: "course-detail" */ '../views/CourseDetailView.vue')
  },
  {
    path: '/recruitment',
    name: 'recruitment',
    component: () => import(/* webpackChunkName: "recruitment" */ '../views/RecruitmentView.vue')
  },
  {
    path: '/membership',
    name: 'membership',
    component: () => import(/* webpackChunkName: "membership" */ '../views/MembershipView.vue')
  },
  {
    path: '/member-services',
    name: 'member-services',
    component: () => import(/* webpackChunkName: "member-services" */ '../views/MemberServiceView.vue')
  },
  {
    path: '/case-law',
    name: 'case-law',
    component: () => import(/* webpackChunkName: "case-law" */ '../views/CaseLawView.vue')
  },
  {
    path: '/search',
    name: 'search',
    component: () => import(/* webpackChunkName: "search" */ '../views/SearchResultView.vue')
  },
  {
    path: '/case-law/:id',
    name: 'case-law-detail',
    component: () => import(/* webpackChunkName: "case-law-detail" */ '../views/CaseLawDetailView.vue')
  },
  {
    path: '/experts',
    name: 'experts',
    component: () => import(/* webpackChunkName: "experts" */ '../views/ExpertTeamView.vue')
  },
  {
    path: '/experts/:id',
    name: 'expert-detail',
    component: () => import(/* webpackChunkName: "expert-detail" */ '../views/ExpertDetailView.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import(/* webpackChunkName: "news" */ '../views/NewsListView.vue')
  },
  {
    path: '/news/:id',
    name: 'news-detail',
    component: () => import(/* webpackChunkName: "news-detail" */ '../views/NewsDetailView.vue')
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import(/* webpackChunkName: "policy" */ '../views/PolicyListView.vue')
  },
  {
    path: '/policy/:id',
    name: 'policy-detail',
    component: () => import(/* webpackChunkName: "policy-detail" */ '../views/PolicyDetailView.vue')
  },
  {
    path: '/dynamics',
    name: 'dynamics',
    component: () => import(/* webpackChunkName: "dynamics" */ '../views/DynamicsListView.vue')
  },
  {
    path: '/dynamics/:id',
    name: 'dynamic-detail',
    component: () => import(/* webpackChunkName: "dynamic-detail" */ '../views/DynamicDetailView.vue')
  },

  // 管理后台路由
  {
    path: '/admin/login',
    name: 'admin-login',
    component: () => import(/* webpackChunkName: "admin-login" */ '../views/admin/LoginView.vue'),
    meta: {
      title: '管理员登录 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin',
    name: 'admin-dashboard',
    component: () => import(/* webpackChunkName: "admin-dashboard" */ '../views/admin/DashboardView.vue'),
    meta: {
      requiresAuth: true,
      title: '管理后台 - 广州市劳动保障学会'
    }
  },
  // 以下是管理后台各模块的路由
  {
    path: '/admin/about',
    name: 'admin-about',
    component: () => import(/* webpackChunkName: "admin-about" */ '../views/admin/AboutManageView.vue'),
    meta: {
      requiresAuth: true,
      title: '学会简介管理 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/news',
    name: 'admin-news',
    component: () => import(/* webpackChunkName: "admin-news" */ '../views/admin/NewsManageView.vue'),
    meta: {
      requiresAuth: true,
      title: '新闻资讯管理 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/news/create',
    name: 'admin-news-create',
    component: () => import(/* webpackChunkName: "admin-news-form" */ '../views/admin/NewsEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '添加新闻 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/news/edit/:id',
    name: 'admin-news-edit',
    component: () => import(/* webpackChunkName: "admin-news-form" */ '../views/admin/NewsEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '编辑新闻 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/policies',
    name: 'admin-policies',
    component: () => import(/* webpackChunkName: "admin-policies" */ '../views/admin/PolicyManageView.vue'),
    meta: {
      requiresAuth: true,
      title: '政策资讯管理 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/policies/create',
    name: 'admin-policy-create',
    component: () => import(/* webpackChunkName: "admin-policy-form" */ '../views/admin/PolicyEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '添加政策 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/policies/edit/:id',
    name: 'admin-policy-edit',
    component: () => import(/* webpackChunkName: "admin-policy-form" */ '../views/admin/PolicyEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '编辑政策 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/dynamics',
    name: 'admin-dynamics',
    component: () => import(/* webpackChunkName: "admin-dynamics" */ '../views/admin/DynamicManageView.vue'),
    meta: {
      requiresAuth: true,
      title: '学会动态管理 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/dynamics/create',
    name: 'admin-dynamic-create',
    component: () => import(/* webpackChunkName: "admin-dynamic-form" */ '../views/admin/DynamicEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '添加动态 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/dynamics/edit/:id',
    name: 'admin-dynamic-edit',
    component: () => import(/* webpackChunkName: "admin-dynamic-form" */ '../views/admin/DynamicEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '编辑动态 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/courses',
    name: 'admin-courses',
    component: () => import(/* webpackChunkName: "admin-courses" */ '../views/admin/CourseManageView.vue'),
    meta: {
      requiresAuth: true,
      title: '培训课程管理 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/courses/create',
    name: 'admin-course-create',
    component: () => import(/* webpackChunkName: "admin-course-form" */ '../views/admin/CourseEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '添加课程 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/courses/edit/:id',
    name: 'admin-course-edit',
    component: () => import(/* webpackChunkName: "admin-course-form" */ '../views/admin/CourseEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '编辑课程 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/recruitment',
    name: 'admin-recruitment',
    component: () => import(/* webpackChunkName: "admin-recruitment" */ '../views/admin/RecruitmentManageView.vue'),
    meta: {
      requiresAuth: true,
      title: '人才招聘管理 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/recruitment/create',
    name: 'admin-recruitment-create',
    component: () => import(/* webpackChunkName: "admin-recruitment-form" */ '../views/admin/RecruitmentEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '添加招聘信息 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/recruitment/edit/:id',
    name: 'admin-recruitment-edit',
    component: () => import(/* webpackChunkName: "admin-recruitment-form" */ '../views/admin/RecruitmentEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '编辑招聘信息 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/caselaws',
    name: 'admin-caselaws',
    component: () => import(/* webpackChunkName: "admin-caselaws" */ '../views/admin/CaseLawManageView.vue'),
    meta: {
      requiresAuth: true,
      title: '以案释法管理 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/caselaws/create',
    name: 'admin-caselaw-create',
    component: () => import(/* webpackChunkName: "admin-caselaw-form" */ '../views/admin/CaseLawEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '添加案例 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/caselaws/edit/:id',
    name: 'admin-caselaw-edit',
    component: () => import(/* webpackChunkName: "admin-caselaw-form" */ '../views/admin/CaseLawEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '编辑案例 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/experts',
    name: 'admin-experts',
    component: () => import(/* webpackChunkName: "admin-experts" */ '../views/admin/ExpertManageView.vue'),
    meta: {
      requiresAuth: true,
      title: '专家团队管理 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/experts/create',
    name: 'admin-expert-create',
    component: () => import(/* webpackChunkName: "admin-expert-form" */ '../views/admin/ExpertEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '添加专家 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/experts/edit/:id',
    name: 'admin-expert-edit',
    component: () => import(/* webpackChunkName: "admin-expert-form" */ '../views/admin/ExpertEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '编辑专家信息 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/memberships',
    name: 'admin-memberships',
    component: () => import(/* webpackChunkName: "admin-memberships" */ '../views/admin/MembershipManageView.vue'),
    meta: {
      requiresAuth: true,
      title: '入会申请管理 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/memberships/create',
    name: 'admin-membership-create',
    component: () => import(/* webpackChunkName: "admin-membership-form" */ '../views/admin/MembershipEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '添加入会申请 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/memberships/edit/:id',
    name: 'admin-membership-edit',
    component: () => import(/* webpackChunkName: "admin-membership-form" */ '../views/admin/MembershipEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '编辑入会申请 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/member-services',
    name: 'admin-member-services',
    component: () => import(/* webpackChunkName: "admin-member-services" */ '../views/admin/MemberServiceManageView.vue'),
    meta: {
      requiresAuth: true,
      title: '会员服务管理 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/member-services/create',
    name: 'admin-member-service-create',
    component: () => import(/* webpackChunkName: "admin-member-service-form" */ '../views/admin/MemberServiceEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '添加会员服务 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/member-services/edit/:id',
    name: 'admin-member-service-edit',
    component: () => import(/* webpackChunkName: "admin-member-service-form" */ '../views/admin/MemberServiceEditView.vue'),
    meta: {
      requiresAuth: true,
      title: '编辑会员服务 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/banners',
    name: 'admin-banners',
    component: () => import(/* webpackChunkName: "admin-banners" */ '../views/admin/BannerManageView.vue'),
    meta: {
      requiresAuth: true,
      title: '轮播图管理 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/messages',
    name: 'admin-messages',
    component: () => import(/* webpackChunkName: "admin-messages" */ '../views/admin/MessageManageView.vue'),
    meta: {
      requiresAuth: true,
      title: '消息管理 - 广州市劳动保障学会'
    }
  },
  {
    path: '/admin/change-password',
    name: 'admin-change-password',
    component: () => import(/* webpackChunkName: "admin-change-password" */ '../views/admin/ChangePasswordView.vue'),
    meta: {
      requiresAuth: true,
      title: '修改密码 - 广州市劳动保障学会'
    }
  },

  // 404 路由 - 管理后台
  {
    path: '/admin/404',
    name: 'admin-not-found',
    component: () => import(/* webpackChunkName: "admin-not-found" */ '../views/admin/NotFoundView.vue'),
    meta: {
      requiresAuth: true,
      title: '页面未找到 - 管理后台 - 广州市劳动保障学会'
    }
  },

  // 404 路由 - 前台
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFoundView.vue'),
    meta: {
      title: '页面未找到 - 广州市劳动保障学会'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // 跳转后自动滚动到页面顶部
    return { top: 0 }
  }
})

// 全局导航守卫，统一设置页面标题与权限控制
router.beforeEach((to, from, next) => {
  // 控制台调试日志（控制台调试功能）
  // console.log('🚀 路由守卫开始执行')
  // console.log('📍 目标路由:', to.path)
  
  // 导入认证工具
  const auth = require('@/utils/auth').default;
  const token = auth.getToken();
  
  // 控制台调试日志（控制台调试功能）
  // console.log('🔑 当前token:', token)
  
  // 如果是后台路由，显示token调试信息（控制台调试功能）
  // if (to.path.startsWith('/admin') && to.path !== '/admin/login') {
  //   const rawToken = localStorage.getItem('admin_token');
  //   if (rawToken) {
  //     auth.debugToken(rawToken);
  //   }
  // }
  
  // 强制测试：如果是后台路由且没有有效token，立即重定向
  if (to.path.startsWith('/admin') && to.path !== '/admin/login') {
    // 控制台调试日志（控制台调试功能）
    // console.log('🚨 后台路由检测，token状态:', !!token)
    
    if (!token || !auth.isTokenValid()) {
      // 控制台调试日志（控制台调试功能）
      // console.log('❌ 无有效token或token已过期，强制重定向到登录页')
      // 清除可能存在的过期token
      if (localStorage.getItem('admin_token')) {
        localStorage.removeItem('admin_token');
      }
      next({ path: '/admin/login', query: { redirect: to.fullPath } })
      return
    }
  }
  
  // 统一设置所有页面的标题
  document.title = '广州市劳动保障学会'
  
  // 检查是否是管理后台路由
  const isAdminRoute = to.path.startsWith('/admin')
  
  // 如果是管理后台路由
  if (isAdminRoute) {
    // 控制台调试日志（控制台调试功能）
    // console.log('🚨 检测到后台路由:', to.path)
    
    // 如果是登录页，直接允许访问
    if (to.path === '/admin/login') {
      // 控制台调试日志（控制台调试功能）
      // console.log('✅ 登录页，允许访问')
      next()
      return
    }
    
    // 检查token是否有效（包括过期检查）
    if (!auth.isTokenValid()) {
      // 控制台调试日志（控制台调试功能）
      // console.log('❌ Token无效或已过期，重定向到登录页')
      // 清除无效token
      localStorage.removeItem('admin_token')
      next({
        path: '/admin/login',
        query: { redirect: to.fullPath }
      })
      return
    }
    
    // 有有效token，检查路由是否存在
    if (to.matched.length === 0) {
      // 控制台调试日志（控制台调试功能）
      // console.log('❌ 路由不存在，重定向到404')
      // 路由不存在，重定向到管理后台404页面
      next({
        path: '/admin/404',
        replace: true
      })
      return
    }
    
    // 控制台调试日志（控制台调试功能）
    // console.log('✅ 路由存在且有有效token，允许访问')
    // 路由存在且有有效token，允许访问
    next()
  } else {
    // 控制台调试日志（控制台调试功能）
    // console.log('✅ 前台路由，允许访问')
    // 前台路由，直接允许访问
    next()
  }
})

// 添加afterEach钩子，确保标题一致性
router.afterEach(() => {
  // 再次设置标题，防止被组件内的mounted等生命周期钩子覆盖
  setTimeout(() => {
    document.title = '广州市劳动保障学会'
  }, 0)
})

// 立即检查当前路由的权限状态
const checkCurrentRouteAuth = () => {
  const currentPath = window.location.pathname
  if (currentPath.startsWith('/admin') && currentPath !== '/admin/login') {
    const auth = require('@/utils/auth').default;
    if (!auth.isTokenValid()) {
      // 控制台调试日志（控制台调试功能）
      // console.log('🚨 当前路由权限检查失败，强制跳转登录页')
      // 清除可能存在的过期token
      if (localStorage.getItem('admin_token')) {
        localStorage.removeItem('admin_token');
      }
      router.push({ path: '/admin/login', query: { redirect: currentPath } })
    }
  }
}

// 页面加载完成后检查权限
if (typeof window !== 'undefined') {
  window.addEventListener('load', checkCurrentRouteAuth)
  // 如果页面已经加载完成，立即检查
  if (document.readyState === 'complete') {
    checkCurrentRouteAuth()
  }
}

export default router
